// 获取指定规则的值
import { Dialog, Toast } from '@zz-common/zz-ui'
export function getRuleValue(rules, ruleName) {
  let value = ''
  if (Array.isArray(rules) && rules.length > 0) {
    const rule = rules.filter((item) => item.name === ruleName)[0]
    if (rule) {
      value = rule.value
    }
  }
  return value
}

// 显示指定规则的提示信息
export function showRuleTips(rules, ruleName) {
  if (Array.isArray(rules) && rules.length > 0) {
    const rule = rules.filter((item) => item.name === ruleName)[0]
    if (rule) {
      const defaultMessage = `规则校验未通过! ${JSON.stringify(rule)}`
      const { messageType, message = defaultMessage } = rule
      if (messageType === 'toast') {
        Toast && Toast(message)
      } else if (messageType === 'alert') {
        Dialog.alert({ message })
      }
    } else {
      Dialog.alert({ message: `未找到指定的规则! ruleName:${ruleName}` })
    }
  }
}
